import { createSlice } from "@reduxjs/toolkit";
import { buscarSaldoInicioFimConsignatario, listarAnexosConsignatario, listarAnexosPrestacaoContaConsignatario, listarSaldoConsignatario } from "../../../services/prestacaoContaService";
import { ArquivoAnexoConsignatarioModel } from "../../../models/vendaConsignatario/arquivoAnexoConsignatarioModel";
import { resetAll } from "../../actions/actions";
import { SaldoConsignatarioModel } from "../../../models/lancamentoConsignatario/saldoConsignatarioModel";
import { SaldoInicioFimConsignatarioModel } from "../../../models/lancamentoConsignatario/saldoInicioFimConsignatarioModel";
import { BuscarSaldoConsignatarioModel } from "../../../models/lancamentoConsignatario/buscarSaldoConsignatarioModel";

export interface PrestacaoContaState {
  //buscar saldo consignatario
  loading: boolean;
  busca: BuscarSaldoConsignatarioModel;
  listSaldo: SaldoConsignatarioModel[];
  entity: SaldoConsignatarioModel;
  //buscar anexos consignatario
  loadingAnexos: boolean;
  listaAnexos: ArquivoAnexoConsignatarioModel[];
  //buscar saldo inicio fim consignatario
  loadingSaldoInicioFim: boolean;
  saldoConsignatario: SaldoInicioFimConsignatarioModel[];
  //buscar anexos prestacao conta consignatario
  loadingAnexosPrestacaoConta: boolean;
  listAnexoGeral: ArquivoAnexoConsignatarioModel[];
  cap: ArquivoAnexoConsignatarioModel[];
  entidade: ArquivoAnexoConsignatarioModel[];
  transferencia: ArquivoAnexoConsignatarioModel[];
  //internal
  avulso: ArquivoAnexoConsignatarioModel[];
}

const initialState: PrestacaoContaState = {
  //buscar saldo consignatario
  loading: false,
  busca: {
    idEmpresa: null,
    idConsignatario: null,
    dataFim: new Date(),
  } as BuscarSaldoConsignatarioModel,
  listSaldo: [],
  entity: {} as SaldoConsignatarioModel,
  //buscar anexos consignatario
  loadingAnexos: false,
  listaAnexos: [],
  //buscar saldo inicio fim consignatario
  loadingSaldoInicioFim: false,
  saldoConsignatario: [],
  //buscar anexos prestacao conta consignatario
  loadingAnexosPrestacaoConta: false,
  listAnexoGeral: [],
  cap: [],
  entidade: [],
  transferencia: [],
  //internal
  avulso: [],
};

export const prestacaoContaSlice = createSlice({
  name: "prestacaoConta",
  initialState,
  reducers: {
    //buscar saldo consignatario
    setBuscaPrestacaoConta: (state, action) => {
      state.busca = action.payload;
    },
    setEntityPrestacaoConta: (state, action) => {
      state.entity = action.payload;
    },
  },
  extraReducers: (builder) => {
    //resetar estados
    builder.addCase(resetAll, () => initialState);

    //buscar saldo consignatario
    builder.addCase(listarSaldoConsignatario.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(listarSaldoConsignatario.fulfilled, (state, action) => {
      state.listSaldo = action.payload;
      state.loading = false;
    });
    builder.addCase(listarSaldoConsignatario.rejected, (state, action) => {
      state.loading = false;
    });

    //buscar anexos consignatario
    builder.addCase(listarAnexosConsignatario.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(listarAnexosConsignatario.fulfilled, (state, action) => {
      state.listaAnexos = action.payload;
      state.loading = false;
    });
    builder.addCase(listarAnexosConsignatario.rejected, (state, action) => {
      state.loading = false;
    });

    //buscar saldo inicio fim consignatario
    builder.addCase(buscarSaldoInicioFimConsignatario.pending, (state) => {
      state.loadingSaldoInicioFim = true;
    });
    builder.addCase(buscarSaldoInicioFimConsignatario.fulfilled, (state, action) => {
      state.saldoConsignatario = action.payload;
      state.loadingSaldoInicioFim = false;
    });
    builder.addCase(buscarSaldoInicioFimConsignatario.rejected, (state, action) => {
      state.loadingSaldoInicioFim = false;
    });

    //buscar anexos prestacao conta consignatario
    builder.addCase(listarAnexosPrestacaoContaConsignatario.pending, (state) => {
      state.loadingAnexosPrestacaoConta = true;
    });
    builder.addCase(listarAnexosPrestacaoContaConsignatario.fulfilled, (state, action) => {
      state.listAnexoGeral = action.payload;
      state.cap = action.payload.filter((anexo: any) => anexo.idTipoArquivoAnexo === 4);
      state.entidade = action.payload.filter((anexo: any) => anexo.idTipoArquivoAnexo === 5);
      state.transferencia = action.payload.filter((anexo: any) => anexo.idTipoArquivoAnexo === 6);
      state.loadingAnexosPrestacaoConta = false;
    });
    builder.addCase(listarAnexosPrestacaoContaConsignatario.rejected, (state, action) => {
      state.loadingAnexosPrestacaoConta = false;
    });
  },
});

export const {
  //buscar saldo consignatario
  setBuscaPrestacaoConta,
  setEntityPrestacaoConta,
} = prestacaoContaSlice.actions;

export default prestacaoContaSlice.reducer;
